// extracted by mini-css-extract-plugin
export default {"Container":"Fans_Container__cOm8A","Loading":"Fans_Loading__Fmir-"};